import { render, staticRenderFns } from "./systemMessage.vue?vue&type=template&id=1b03ffd7&scoped=true&"
import script from "./systemMessage.vue?vue&type=script&lang=js&"
export * from "./systemMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b03ffd7",
  null
  
)

export default component.exports